module.exports = __webpack_public_path__ + "posture/static/img/head_lean_normal.c54b536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/head_lean_normal.png
// module id = yujV
// module chunks = 1